import { requests } from '../../agent/agent';
import { PromotionForGetAllUserPromotions } from './responses/getAllUserPromotionsResponse';

export const UserPromotionsApi = {
	getAllUserPromotions: (): Promise<PromotionForGetAllUserPromotions[]> => requests.get('/client/promotions'),

	addDiscountCodePromotion: (code: string): Promise<any> => requests.post(`/client/promotions/codes`, { discount_code: code }),
};
